import { ROUTES } from "../constant/paths";
import { isAppEmbedFlow } from "./embedPortalBridge";

const EMBED_ROUTE_REWRITES: Record<string, string> = {
  [ROUTES.Home]: ROUTES.PortalChat,
  [ROUTES.NewTrip]: ROUTES.PortalChat,
  [ROUTES.MyTrips]: ROUTES.PortalTrips,
  [ROUTES.History]: ROUTES.PortalHistory,
  [ROUTES.BookingInProgress]: ROUTES.PortalShop,
};

const chatRouteForEmbed = (): string =>
  typeof window !== "undefined" && window.location.pathname === ROUTES.PortalHistory
    ? ROUTES.PortalHistory
    : ROUTES.PortalChat;

export const portalRouteFor = (path: string): string => {
  if (typeof path !== "string") return path;
  const [bare, query] = path.split("?");
  const rewritten = bare === ROUTES.TopDestination ? chatRouteForEmbed() : EMBED_ROUTE_REWRITES[bare];
  if (!rewritten || !isAppEmbedFlow()) return path;

  const params = new URLSearchParams(query || "");
  params.set("embed", "1");
  return `${rewritten}?${params.toString()}`;
};

type RawNavigate = (to: string, options?: { replace?: boolean; state?: unknown }) => void;

export const portalNavigate = (
  navigate: RawNavigate,
  path: string,
  options?: { replace?: boolean; state?: unknown },
): void => {
  const target = portalRouteFor(path);
  const [bare] = target.split("?");
  if (isAppEmbedFlow() && bare === window.location.pathname) return;
  navigate(target, options);
};
